import React from 'react';
import { AlertCircle } from 'lucide-react';

interface LocationWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LocationWarningModal: React.FC<LocationWarningModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <div className="flex items-start gap-3 mb-4">
          <AlertCircle className="h-6 w-6 text-amber-600 flex-shrink-0" />
          <h3 className="text-lg font-medium text-gray-900">Location Verification Warning</h3>
        </div>
        
        <div className="space-y-3 text-sm text-gray-600 mb-6">
          <p>You are about to capture your location for a <strong>Home address</strong>.</p>
          <p className="font-medium text-amber-700">Important:</p>
          <ul className="list-disc ml-4 space-y-1">
            <li>You must be at your actual home address</li>
            <li>Do not submit work addresses or false locations</li>
            <li>False submissions will be rejected</li>
            <li>Repeated violations may result in account suspension</li>
          </ul>
        </div>
        
        <div className="flex gap-3">
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="flex-1 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700"
          >
            I Understand, Proceed
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocationWarningModal;